import { getDifferenceInDays } from 'utils/date';

export const BuildRequestDataFromOrder = (
  order,
  paymentMethod = 'bankSlip'
) => {
  const { buyer } = order;

  return {
    paymentMethod,
    address: buyer.street,
    number: buyer.number,
    city: buyer.city,
    cep: buyer.zipCode,
    complement: buyer.complement,
    cpfCnpj: buyer.cpfCnpj,
    name: buyer.name,
    phone: buyer.phone,
    phonePrefix: buyer.phonePrefix,
    email: buyer.email,
  };
};

export const createRequestToPayment = (
  data,
  hashValue,
  installments = 1,
  token = null,
  unitValueInCents = 0,
  installment = {},
  flag = null
) => ({
  dueDate: data.dueDate,
  hash: hashValue,
  installment,
  installments,
  token,
  flag,
  type: data.paymentMethod === 'bankSlip' ? 0 : 1,
  paymentHub: {
    payments: [
      {
        bankSlipExtraDays: 1,
        competence: new Date(),
        currency: 'BRL',
        customerId: '',
        customerPaymentMethodId: null,
        discountCents: 0,
        email: data.email,
        installments,
        keepDunning: false,
        flag,
        products: [
          {
            description: 'Intercâmbio',
            quantity: 1,
            unitValueInCents,
          },
        ],
        token,
        type: data.paymentMethod,
      },
    ],
  },
});

export const createRequestToIugu = (data) => {
  const nameArray = data.cardName.split(' ');
  const name = nameArray[0];
  const date = data.expire.split('/');

  return {
    number: data.cardNumber,
    verification_value: data.cvv,
    first_name: name,
    last_name: nameArray[1],
    month: date[0],
    year: date[1],
  };
};

export const createRequestToCreateStudent = (data, enroll, exp) => {
  const birthdateFormat = new Date(
    data.birthDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3')
  );
  const polishedObject = polishObjectWithGuardian(data);

  return {
    ...polishedObject,
    birthDate: birthdateFormat,
    secondName: polishedObject?.surname || '',
    user: {
      name: `${polishedObject?.firstName} ${polishedObject?.surname}`,
      email: polishedObject?.email,
    },
    enroll: !!enroll,
    expert: parseInt(exp, 10),
  };
};

export const polishObjectWithGuardian = (data) => {
  if (data?.guardianNameContact) {
    data.guardian = {
      cpfContact: data?.guardianCpfContact,
      emailContact: data?.guardianEmailContact,
      nameContact: data?.guardianNameContact,
      phoneContact: data?.guardianPhoneContact,
      relationshipContact: data?.guardianRelationshipContact,
    };

    delete data?.guardianCpfContact;
    delete data?.guardianEmailContact;
    delete data?.guardianNameContact;
    delete data?.guardianPhoneContact;
    delete data?.guardianRelationshipContact;

    return data;
  }

  return data;
};

// checkout deve receber valor do depósito do back
export const calcDepositMinimum = (value, boardDate, minimumPayment = null) => {
  if (
    boardDate !== undefined &&
    getDifferenceInDays(boardDate, new Date()) <
      parseInt(process.env.DAYS_BEFORE_BOOKING, 10)
  ) {
    return value;
  }

  let depositMinimum = parseInt(process.env.DEPOSIT_MINIMUM, 10);
  const depositPercentage = value * (process.env.DEPOSIT_PERCENTAGE / 100);

  if (minimumPayment && minimumPayment > depositMinimum)
    depositMinimum = minimumPayment;

  return depositPercentage < depositMinimum
    ? parseFloat(depositMinimum)
    : parseFloat(depositPercentage);
};

export const setUrl = (step) => {
  const urlSplit = window.location.href.split('/');
  let url = urlSplit[2];

  switch (step) {
    case 1:
      url += `/registration/${urlSplit[4]}`;

      break;
    case 2:
      url += `/book/${urlSplit[4]}`;
      break;
    case 3:
      url += `/confirmation/${urlSplit[4]}`;
      break;

    default:
      break;
  }

  window.history.pushState(new Date(), '', `${urlSplit[0]}//${url}`);
};

export const removeEnrollParam = () => {
  const urlSplit = window.location.href.split('?');
  const url = urlSplit[0];

  if (urlSplit[1] && urlSplit[1].match(/enroll/g))
    window.history.pushState(new Date(), '', `${url}`);
};
